import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveCredentials } from '../api/admin-client';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!token.trim()) {
      setError('Bearer token is required.');
      return;
    }
    saveCredentials(token.trim(), email.trim());
    navigate('/', { replace: true });
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-title">Lords Admin</div>
        <div className="login-subtitle">
          Enter your admin Bearer token. Obtain one via{' '}
          <code>node server/tools/grant-admin-role.mjs</code> or from an existing admin session.
        </div>

        {error && <div className="error-banner" style={{ marginBottom: 16 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="login-token">Bearer Token</label>
            <input
              id="login-token"
              type="password"
              placeholder="eyJ..."
              value={token}
              onChange={(e) => setToken(e.target.value)}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="login-email">Your admin email (optional — display only)</label>
            <input
              id="login-email"
              type="text"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
            Save &amp; Enter
          </button>
        </form>
      </div>
    </div>
  );
}
